import * as PropTypes from "prop-types";
import {connect} from 'react-redux';
import {Component} from "react";
import * as React from "react";
import {Field} from "redux-form";
import FileUploadPanel from "../../components/FileUploadPanel";

/**
 * Redux-form kompatibilní field obalující komponentu pro nahrávání souborů.
 */
class FileUploadField extends Component {

    static propTypes = {
        name: PropTypes.string.isRequired, // název fieldu
        onChange: PropTypes.func, // funkce volaná při změně metadat souborů
    };

    render() {
        const {name, onChange, ...other} = this.props;
        return <Field name={name} onChange={onChange} component={FileUploadPanel} {...other}/>
    }
}

export default connect()(FileUploadField);
